"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NetInfoInstance = exports.NetInfoSchema = void 0;
const zod_1 = require("zod");
const zod_partial_1 = require("../Utils/zod-partial");
const DifferentialPair_1 = require("./DrawingModels/DifferentialPair");
const metadata_1 = require("./metadata");
const nets_1 = require("./nets");
const ProjectDataTypeInstance_1 = require("./ProjectInstances/ProjectDataTypeInstance");
exports.NetInfoSchema = zod_1.z.object({
    name: zod_1.z.string(),
    metadata: metadata_1.MetadataSchema.optional(),
    connections: nets_1.NetConnectionSchema.array(),
    diffPair: DifferentialPair_1.DifferentialPairSchema.optional(),
    isGlobal: zod_1.z.boolean().optional(),
    isHierarchical: zod_1.z.boolean().optional(),
});
class NetInfoInstance extends ProjectDataTypeInstance_1.ProjectDataTypeInstance {
    constructor(context, rawOpts) {
        super(context);
        this.connections = [];
        const { name, ...rest } = rawOpts;
        const opts = (0, zod_partial_1.partialWithoutDefaults)(exports.NetInfoSchema).parse(rest);
        this.name = this.netRefCtx.existingOrNewRef(name);
        this.metadata = opts.metadata;
        this.connections = opts.connections ?? [];
        this.diffPair = opts.diffPair;
        this.isGlobal = opts.isGlobal;
        this.isHierarchical = opts.isHierarchical;
    }
    toJSON() {
        return {
            name: this.name.valueOf(),
            metadata: this.metadata,
            connections: this.connections,
            diffPair: this.diffPair,
            isGlobal: this.isGlobal,
            isHierarchical: this.isHierarchical,
        };
    }
    merge(other) {
        this.name = other.name ? this.netRefCtx.existingOrNewRef(other.name) : this.name;
        this.diffPair = other.diffPair ?? this.diffPair;
        this.isGlobal = other.isGlobal ?? this.isGlobal;
        this.isHierarchical = other.isHierarchical ?? this.isHierarchical;
        this.metadata = {
            ...(this.metadata ?? {}),
            ...(other.metadata ?? {}),
        };
        this.connections = Array.from(new Set([...this.connections, ...(other.connections ?? [])]));
        return this;
    }
}
exports.NetInfoInstance = NetInfoInstance;
//# sourceMappingURL=NetInfo.js.map